import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  ReportTemplate,
  ReportTemplateUpdate,
  ReportTemplateNew,
  ReportTemplateListItem,
  EditableTextList,
  ResponseIdList,
  UpdateIdList, UpdateResultList, ReportTemplateImageList
} from '../../_offline/models/report-preview/report-template';
import { ReportTemplateContractService } from '../interfaces/report-template-contract.service';
import { ApiService } from '../base/api-base.service';
import { NetworkStatusService } from '../network-status.service';
import { ReportTemplateOnlineService } from '../online/report-template-online.service';
import { ReportTemplateOfflineService } from '../offline/report-template-offline.service';

@Injectable()
export class ReportTemplateService extends ApiService<ReportTemplateContractService> implements ReportTemplateContractService {

  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: ReportTemplateOfflineService,
    protected onlineService: ReportTemplateOnlineService) {
    super(networkStatusService, offlineService, onlineService);
  }

  // TP01 GET /api/v1/templates
  getReportTemplates(subjectModelId?: string, enabledOnly?: boolean): Observable<ReportTemplateListItem[]> {
    return this.service.getReportTemplates(subjectModelId, enabledOnly);
  }

  // TP02 GET /api/v1/templates/{templateId}
  getReportTemplate(reportTemplateId: string): Observable<ReportTemplate> {
    return this.service.getReportTemplate(reportTemplateId);
  }

  // TP07 GET /api/v1/templates/{templateId}/editableTexts
  getEditableTexts(reportTemplateId: string, reportId: string): Observable<EditableTextList[]> {
    return this.service.getEditableTexts(reportTemplateId, reportId);
  }

  // TP04 PUT /api/v1/templates/{templateId}
  updateReportTemplate(reportTemplateUpdate: ReportTemplateUpdate): Observable<ReportTemplate> {
    return this.service.updateReportTemplate(reportTemplateUpdate);
  }

  // TP03 POST /api/v1/templates
  addReportTemplate(reportTemplateNew: ReportTemplateNew): Observable<ReportTemplate> {
    return this.service.addReportTemplate(reportTemplateNew);
  }

  // TP05 GET /api/v1/templates/{templateId}/export
  exportReportTemplate(reportTemplateId: string): Observable<Blob> {
    return this.service.exportReportTemplate(reportTemplateId);
  }

  // TP06 PUT /api/v1/templates/import
  importReportTemplate(file: File, reportTemplate?: ReportTemplateListItem): Observable<HttpEvent<{}>> {
    return this.service.importReportTemplate(file, reportTemplate);
  }

  // TP08 GET /api/v1/templates/models
  getModelsForTemplates(reportTemplateId?: string, subjectModelId?: string): Observable<ResponseIdList[]> {
    return this.service.getModelsForTemplates(reportTemplateId, subjectModelId);
  }

  // TP09 PUT /api/v1/templates/{templateId}/models
  updateModelsForTemplates(templateId: string, updateModelIdList: UpdateIdList): Observable<UpdateResultList> {
    return this.service.updateModelsForTemplates(templateId, updateModelIdList);
  }

  // TP10 GET /api/v1/templates/{templateId}/images
  getReportTemplateImages(templateId: string): Observable<ReportTemplateImageList[]> {
    return this.service.getReportTemplateImages(templateId);
  }
  // TP11 POST /api/v1/templates/{templateId}/images
  updateReportTemplateImage(templateId: string, file: File): Observable<HttpEvent<{}>> {
    return this.service.updateReportTemplateImage(templateId, file);
  }
  // TP12 DELETE /api/v1/templates/{templateId}/images
  deleteReportTemplateImage(templateId: string, fileName: string): Observable<any> {
    return this.service.deleteReportTemplateImage(templateId, fileName);
  }

  /** 【TP13】 レポートテンプレートを削除
   * DELETE /api/v1/templates/{templateId}
   * @param  {string} templateId
   * @returns Observable
   */
  deleteReportTemplate(templateId: string): Observable<any> {
    return this.service.deleteReportTemplate(templateId);
  }
}
